import { makeStyles } from '@material-ui/core';

const drawerWidth = 225;

const drawerCollapsedWidth = 82;

export default makeStyles(theme => ({

  drawer: {
    width: drawerWidth,
    height: '100vh',
    paddingBottom: 10,
    background: '#fff',
    transition: 'width 0.3s ease-out',
    overflowX: 'hidden'
  },

  drawerCollpased: {
    width: drawerCollapsedWidth,
    transition: 'width 0.3s ease-out',
    overflowX: 'hidden'
  },

  drawerHeader: {
    position: 'relative',
    padding: '0 5px',
    marginBottom: 5,

    '& button': {
      background: '#bebebe',
      color: '#fff',
      position: 'absolute',
      bottom: -13,
      right: 0,
      padding: 0,
      fontSize: 21,

      '&:hover': { background: 'grey' }

    }

  },

  menuItem: {
    display: 'block !important',
    padding: '5px 10px !important',
    margin: '5px 0 0 5px',
    borderRadius: 8,
    color: 'rgb(30, 40, 49, 0.7)',
    fontSize: 15,

    '&:hover': {

      '&>a': {
        color: 'rgb(30, 40, 49, 1)',

        '& svg': {
          color: 'rgb(0, 0, 0, 1)',
          opacity: 1
        }
      }
    },

    '&>button': {
      fontSize: 15,

      '&:hover': { background: 'transparent' }
    },

    '& a': {
      color: 'rgb(30, 40, 49, 0.7)',
      textDecoration: 'none'
    },

    '& ul': { marginLeft: 11 },

    '& svg': { fontSize: 21, opacity: '0.4', width: 20 }

  },

  menuItemClosed: { width: 42 },

  activeMenuItem: {
    position: 'relative',
    background: 'rgba(249, 211, 66, 0.2)',

    '& a': {
      color: '#1a1a1a !important',

      '& svg': {
        color: 'rgb(0, 0, 0, 1)',
        opacity: 1
      }
    },

    '&:before': {
      content: '" "',
      position: 'absolute',
      top: 2,
      bottom: 2,
      width: 3,
      left: -12,
      background: '#f8c500'
    }
  },

  innerMenuItem: {
    borderRadius: 5,
    padding: '5px 10px',

    '&:before': { left: -33 },

    '& svg': { fontSize: 18 },

    '& a': {
      color: 'rgb(30, 40, 49, 0.7)',
      textDecoration: 'none',

      '&:hover': {
        color: 'rgb(30, 40, 49, 1)',

        '& svg': {
          color: 'rgb(0, 0, 0, 1)',
          opacity: 1
        }
      }
    },
  },

  menuItemBox: {
    display: 'flex',
    gap: 18,
    gridGap: 18,
    '&:hover': {

      '& a': {
        color: 'rgb(30, 40, 49, 1)',

        '& svg': {
          color: 'rgb(0, 0, 0, 1)',
          opacity: 1
        }
      }
    },
    '& button': { padding: 0, color: 'rgb(30, 40, 49, 0.7)' }
  },

  menuItemBoxClosed: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 5
  },

  actionItemsDisabled: {
    display: 'flex',
    alignItems: 'center',
    gap: 18,
    gridGap: 18,
    color: 'rgb(30, 40, 49, 0.3)',
    padding: '6px',
    border: 0,
    fontSize: 15,
    cursor: 'auto',

    '& svg': {
      opacity: 0.3,
      height: 22.5
    },
  },

  actionItems: {
    margin: '0',
    padding: '5px 0 0 5px',

    '& button, & a': {
      display: 'flex',
      alignItems: 'center',
      gap: 18,
      gridGap: 18,
      color: 'rgb(30, 40, 49, 0.7)',
      padding: '6px',
      border: 0,
      fontSize: 15,
      cursor: 'pointer',
      textDecoration: 'none',
      width: '100%',
      borderTopLeftRadius: 8,
      borderBottomLeftRadius: 8,

      '& svg': { opacity: 0.4, height: 22.5 },

      '&:focus': {
        color: 'rgb(30, 40, 49, 1)',

        '& svg': {
          color: 'rgb(0, 0, 0, 1)',
          opacity: 1
        }
      },

      '&:hover': {
        color: 'rgb(30, 40, 49, 1)',

        '& svg': {
          color: 'rgb(0, 0, 0, 1)',
          opacity: 1
        }
      }
    },
    '& button': {
      background: 'transparent',
    },
  },
  closeIcon: { fontSize: 16 },
  userAction: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  userActionItem: {
    marginLeft: '-2px',

    '& span': { marginLeft: 10 }
  },
  actionItemClosed: {
    width: '42px !important',
    borderRadius: 8
  },
  actionsMenuContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%'
  },
  avatar: {
    background: 'rgba(29, 56, 83, 0.4)'
  }
}));
